import styled from 'styled-components';
import { tint } from 'polished';

type HighlightSelectedProps = {
  isSelected: boolean;
  theme: any;
};
export const HighlightSelected = styled.div<HighlightSelectedProps>`
  background-color: ${({ isSelected, theme }) =>
    isSelected ? tint(0.9, theme.customColors.primary) : 'none'};
`;
